import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTimeSeriesData } from "../../api/timeseriesApi";
import { selectManyTimeSeriesData } from "../../store/slices/timeseries.slice";
import { getDateFromLookback } from "../../utils/datetime";
import NavTrail from '../../layouts/NavTrail';
import VolatilityCard from './MarketViews/VolatilityCard';
import YieldsCard from './MarketViews/YieldsCard';
import ForeignIndicesCard from './MarketViews/ForeignIndicesCard';
const VolatilityIndices = ['^vix9d', '^vix', '^vix6m'];
const YieldIndices = ['^tnx', '^fvx', '^irx'];
const ForeignIndices = ['vxus', 'efa', 'eem']

const FactorView = () => {
  const dispatch = useDispatch();
  const timeSeriesData = useSelector(state =>
    selectManyTimeSeriesData(state, [...VolatilityIndices, ...YieldIndices, ...ForeignIndices])
  );

  useEffect(() => {
    const lookback = 60;
    const startDate = getDateFromLookback(lookback, 'day');
    const symbols = [...VolatilityIndices, ...YieldIndices, ...ForeignIndices];
    dispatch(fetchTimeSeriesData({ symbols, startDate }));
  }, [dispatch]);

  // Format data for volatility card
  const volatilityData = {
    vix: timeSeriesData.find(item => item.symbol === '^vix')?.data || [],
    vix9d: timeSeriesData.find(item => item.symbol === '^vix9d')?.data || [],
    vix6m: timeSeriesData.find(item => item.symbol === '^vix6m')?.data || []
  };

  // Format data for yields card
  const yieldsData = {
    tnx: timeSeriesData.find(item => item.symbol === '^tnx')?.data || [],
    fvx: timeSeriesData.find(item => item.symbol === '^fvx')?.data || [],
    irx: timeSeriesData.find(item => item.symbol === '^irx')?.data || []
  };

  const foreignData = {
    vxus: timeSeriesData.find(item => item.symbol === 'vxus')?.data || [],
    efa: timeSeriesData.find(item => item.symbol === 'efa')?.data || [],
    eem: timeSeriesData.find(item => item.symbol === 'eem')?.data || []
  }

  const trailConfig = [
    {label: "BETA", path: '/beta/launcher'},
    {label: "Factor View"}
  ];

  return (
    <div style={{background: '#ECEDF2'}} className={'h-full'}>
      <NavTrail items={trailConfig}/>
      <div className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {
            yieldsData?.tnx?.length > 0 && volatilityData?.vix?.length > 0 && (
                <>
                  <VolatilityCard data={volatilityData} />
                  <YieldsCard data={yieldsData} />
                  <ForeignIndicesCard data={foreignData} />
                </>
              )
          }
        </div>
      </div>
    </div>
  );
};

export default FactorView;